let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fLh1T")).then(() => parcelRequire('kYXyk'));